module.exports = __webpack_public_path__ + "static/spinner-3422cdec509fa2bab9aed47acce4ee52.png";